import React from "react";
import { useTranslation } from "react-i18next";
import { Footer } from "extranet-component-library";
import { MENU } from "../utils/constants";
import tib from "../assets/img/TIB.svg";
const { REACT_APP_BASE_URL } = process.env;

const FooterComp = () => {
    const { t } = useTranslation();

    return (
        <Footer
            footerImage={tib}
            voText={t(MENU.CONTACT.LABEL)}
            voUrl={`${REACT_APP_BASE_URL}/${t("urls.vo")}`}
            items={[
                {
                    label: t("footer.privacy"),
                    url: `${REACT_APP_BASE_URL}/${t("urls.privacy")}`,
                },
                {
                    label: t("footer.cookies"),
                    url: `${REACT_APP_BASE_URL}/${t("urls.cookies")}`,
                },
                { label: t("footer.consortium") },
            ]}
        />
    );
};

export default FooterComp;
